module.exports = __webpack_public_path__ + "static/media/psat.ce17dca7.JPG";